'use client'

import { Spinner } from '@lastbrand/web-ui/spinner'
import { css, cx } from '@lastbrand/web-ui-styled-system/css'

import type { LoaderDSProps } from './loader-ds.types'

// eslint-disable-next-line i18next/no-literal-string -- Panda CSS layout values (not user-facing copy)
const loaderWrapperClass = css({
  position: 'relative',
  my: 'space-64',
  mx: 'auto',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
})

const spinnerColorCss = {
  // eslint-disable-next-line i18next/no-literal-string -- Panda color tokens (not user-facing copy)
  '& circle:first-child': { stroke: 'black', opacity: 1 },
  // eslint-disable-next-line i18next/no-literal-string -- Panda color token (not user-facing copy)
  '& circle:last-child': { stroke: 'cantaloupe-100' },
}

export function LoaderDS({ showLoader, loadWrapperClassName, minHeight, loaderSize = '40px' }: LoaderDSProps) {
  return (
    <div
      style={{ display: showLoader ? 'flex' : 'none', minHeight, alignItems: 'center' }}
      className={cx(loaderWrapperClass, loadWrapperClassName)}
    >
      <Spinner style={{ width: loaderSize, height: loaderSize }} css={spinnerColorCss} />
    </div>
  )
}
